<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { storeToRefs } from "pinia"
import { useHomeWorkspaceStore } from "@modules/home/stores/homeStore.store"

defineOptions({
    name: "HomeExportDialogs",
})

// ================================
// COMPOSABLES
// ================================
const homeWorkspace = useHomeWorkspaceStore()
const { modal } = storeToRefs(homeWorkspace)

// ================================
// INTERACTIONS
// ================================
/**
 * Ferme le store workspace quand la modale d’export (équivalent legacy ModalExportAllData) se ferme.
 */
function onUpdateExportModalVisible(visible: boolean): void {
    if (!visible) {
        homeWorkspace.closeModal()
    }
}
</script>

<template>
    <!-- ================================ -->
    <!-- DIALOGUE — EXPORT GLOBAL (formulaire complet) -->
    <!-- ================================ -->
    <DashboardExportDialog
        :visible="modal.kind === 'exportAllData'"
        @update:visible="onUpdateExportModalVisible"
    />
</template>
